export class OriginatingSystem {
  public static readonly Insurance = 'INS';
  public static readonly Roadside = 'RSA';
}

export type TOriginatingSystem = 
    typeof OriginatingSystem.Insurance | 
    typeof OriginatingSystem.Roadside;